import {
    // CustomFrame, 
    OldPatternTitle, KoreanPhrase, TagLine, TransitioningPhrase,
} from './elements';
import StartFinishButton from './elements/StartFinishButton';
import PatternTitle from './elements/PatternTitle';
import Text from './elements/Text';
import { MissingElement } from './elements/Element';
// import PatternVariantApplication from './elements/PatternVariantApplication';
// import PatternApplication from './elements/PatternApplication';
import PatternAnimation from './elements/PatternAnimation';
import PhraseBoard from './elements/PhraseBoard';
import PhraseSequence from './elements/PhraseSequence';
import VocabCard from './elements/VocabCard';
import HintButton from './elements/HintButton';
import Phrase from './elements/Phrase';
import PickOne from './elements/PickOne';
import PatternVariantsSummary from './elements/PatternVariantsSummary';
import PatternSummary from './elements/PatternSummary';
import MiniLessonTable from './elements/MiniLessonTable';
import LessonCardElement from './elements/LessonCardElement';
import MiniLessonCard from './elements/MiniLessonCard';
import IrregularLessonCard from './elements/IrregularLessonCard';
import SentenceBuilder from './elements/SentenceBuilder';
import ListButton from './elements/ListButton';
import Drag from './elements/Drag';
import VideoClip from './elements/VideoClip';
import StaticPattern from './elements/StaticPattern';
import PatternCallout from './elements/PatternCallout';
import CultureExample from './elements/CultureExample';
import TextAudio from './elements/TextAudio';
import SubTitledVideoClip from './elements/SubTitledVideoClip';
import VariantsTable from './elements/VariantsTable';
import Image from './elements/Image';
import PracticeListening from './elements/PracticeListening';
import PracticeTyping from './elements/PracticeTyping';
import LetterCard from './elements/LetterCard';
import WordCard from './elements/WordCard';
import BatchimCard from './elements/BatchimCard';
import HelpBubble from './elements/HelpBubble';
import ImageCard from './elements/ImageCard';
import TextCard from './elements/TextCard';
import PickALetter from './elements/PickALetter';
import MatchTheLetters from './elements/MatchTheLetters';
import AdvancedVariantsTable from './elements/AdvancedVariantsTable';
import AdvancedTyping from './elements/AdvancedTyping';
import IdiomImageCard from './elements/IdiomImageCard';
import IdiomTextCard from './elements/IdiomTextCard';

import graphicComponents from './graphicComponentMap';

// maps element node types to the React compoennts that will render them
export const elementComponents = {
    tagLine:                    TagLine,
    patternTitleBlock:          OldPatternTitle,
    phrase:                     Phrase,
    koreanPhrase:               KoreanPhrase,
    // 'custom-frame':             CustomFrame,
    transitioningPhrase:        TransitioningPhrase,
    startButton:                StartFinishButton,
    finishButton:               StartFinishButton,
    continueButton:             StartFinishButton,
    startPageTitle:             PatternTitle,
    patternTitle:               PatternTitle,
    customPatternTitle:         PatternTitle,
    text:                       Text,
    goalText:                   Text,
    goalTitle:                  Text,
    goodJobText:                Text,
    congratsText:               Text,
    irregularTitle:             Text,
    completeGoalText:           Text,
    irregularCongratsText:      Text,
    patternAnimation:           PatternAnimation,
    verbConjugation:            PatternAnimation,
    conjugationExample:         PatternAnimation,
    introductoryVerbConjugation: PatternAnimation,
    introductoryAuxiliaryVerb:  PatternAnimation,
    sentenceForm:               PatternAnimation,
    sentenceFormExample:        PatternAnimation,
    // the following to be updated to new PatternAnimation component, do not update for mobile
    //irregularConjugation:       PatternApplication,
    //attachParticle:             PatternApplication,
    //introductoryAttachParticle: PatternApplication,
    // ^^
    //introductoryAuxiliaryVerbV1: PatternApplication, // deprecated
    // patternVariantApplication:  PatternVariantApplication, // deprecated
    bubbleTextUp:               Text,
    bubbleTextDown:             Text,
    phraseBoard:                PhraseBoard,
    phraseSequence:             PhraseSequence,
    directionsText:             Text,
    callToActionText:           Text,
    vocabCard:                  VocabCard,
    hintButton:                 HintButton,
    pickOne:                    PickOne,
    patternVariantsSummary:     PatternVariantsSummary,
    patternSummary:             PatternSummary,
    miniLessonTable:            MiniLessonTable,
    lessonCard:                 LessonCardElement,
    miniLessonCard:             MiniLessonCard,
    irregularLessonCard:        IrregularLessonCard,
    completeThePhrase:          SentenceBuilder,
    listButton:                 ListButton,
    specialListButton:          ListButton,
    drag:                       Drag,
    videoClip:                  VideoClip,
    subTitledVideoClip:         SubTitledVideoClip,
    staticPattern:              StaticPattern,
    patternCallout:             PatternCallout,
    cultureExample:             CultureExample,
    // meaningAudioHint:           TextAudio,
    conversationAudio:          TextAudio,
    variantsTable:              VariantsTable,
    advancedVariantsTable:      AdvancedVariantsTable,
    image:                      Image,
    practiceListening:          PracticeListening,
    practiceTyping:             PracticeTyping,
    letterCard:                 LetterCard,
    wordCard:                   WordCard,
    helpBubble:                 HelpBubble,
    batchimCard:                BatchimCard,
    annotation:                 Text,
    imageAndTextTitle:          Text,
    imageCard:                  ImageCard,
    textCard:                   TextCard,
    pickALetter:                PickALetter,
    makeTheWord:                PhraseSequence,
    matchTheLetters:            MatchTheLetters,
    advancedTyping:             AdvancedTyping,
    idiomImageCard:             IdiomImageCard,
    idiomTextCard:              IdiomTextCard,

    ...graphicComponents,
};

export const getElementComponent = (element) => elementComponents[element.componentName || element.type] || MissingElement;
